module.exports = __webpack_public_path__ + "static/media/stella.93a8900b.png";